import React from "react";
import './Home.css'

const Home = () => {
    return (
        <div id="home">
            <h1 id="welcome">Hello, Welcome to my personal website!</h1>
            <p id="Quote">"In the darkest times, hope is something you give yourself. That is the meaning of inner strength"</p>
            <p id="Quote">~Uncle Iroh</p>
            <img id="uncleIroh" src="https://avatarthelastairbender.store/wp-content/uploads/2021/07/Iroh-Merch.jpg" alt="" />
        </div>
    )
}

export default Home;